import React from 'react';
import {
  func,
  shape,
  string,
} from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { CTA_EVENT_NAME } from '../../constants';
import { handleMktAnalytics } from '../../AmexUtils';
import './AmexMarketingEditorialsCard.scss';

const AmexMarketingEditorialsCard = (
  {
    editorialsImagePath,
    Analytics,
    post: {
      image,
      title,
      url,
    },
    utm,
  }
) => {
  const imgUrl = `${editorialsImagePath}editorials/images/${image}`;
  const sanitizedTitle = sanitizeString(title);

  return (
    <li className="AmexMarketingEditorialsCard__item">
      <Link
        href={`${url}${utm}`}
        variant="article"
        target="_blank"
        onClick={() => {
          const extraParam = {
            action_name: 'Editorial - Click',
            item_name: sanitizedTitle,
          };
          handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
        }}
      >
        <div
          className="AmexMarketingEditorialsCard__image"
          style={{
            backgroundImage: `url(${imgUrl})`,
          }}
        />
        <h3
          className="AmexMarketingEditorialsCard__title"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizedTitle,
          }}
        />
      </Link>
    </li>
  );
};

AmexMarketingEditorialsCard.propTypes = {
  editorialsImagePath: string.isRequired,
  Analytics: shape({
    event: func,
  }).isRequired,
  post: shape({
    image: string.isRequired,
    title: string.isRequired,
    url: string.isRequired,
  }).isRequired,
  utm: string.isRequired,
};
export default AmexMarketingEditorialsCard;
